import React from "react";
import './student-engagement-report.scss';
import Dropdown from '../common/dropdown-v2/dropdown';
import SchoolApi from "../../apis/school";
import DropdownV4 from "../common/dropdown-v4/dropdown";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Loading from "../common/loading/loading";

class StudentEngagementReport extends React.Component {


    state = {
        boardsDropdownItems: [],
        classDropdownItems: [],
        reloadDropdown: false,
        reloadSubjectDropdown : false,
        selectedBoard: '',
        isCreate: false,
        selectedClass: [],
        selectedCreatedDateRange: '',
        subjectsDropdownItems: [],
        selectedSubject: '',
        createdDate: '',
        monthsDrodownItems: [
            {
                title: 'September 2025',
                value: 'September 2025'
            }
        ]
    }



    componentDidMount() {
        this.getClasses()
        this.getSubjectsList()
    }

    getClasses(payload = {}) {

        this.setState({ isLoading: true })

        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = []
                this.setState({ isLoading: false })
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }
                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name })
                }
                this.setState({ classDropdownItems: classes, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    getSubjectsList() {
        this.setState({ isLoading: true })

        SchoolApi.getSubjectsList({})
            .then(res => {
                console.log(res)
                this.setState({ subjectsDropdownItems: res.subjects, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    onSelectDropDown = (option, key) => {
        // console.log(option, key)

        this.setState({ [key]: option?.value, }, () => {
            if (key === "selectedBoard" || key === "selectedSubject") {
                this.clearFiltersForClass()
            }
        })
    }

    clearFiltersForClass = () => {
        this.setState({ selectedClass: [], selectedCreatedDateRange: '', isCreate: false, reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }



    handleCreatedDateEvent = (event, picker) => {
        // this.createdStartDate = new Date(picker.startDate);
        // this.createdEndDate = new Date(picker.endDate);

        this.createdDateRangeStart = new Date(picker.startDate);
        this.createdDateRangeEnd = new Date(picker.endDate).toLocaleDateString() === new Date().toLocaleDateString() ? new Date() : new Date(picker.endDate);

        this.setState({ createdDate: this.createdDateRangeStart.toLocaleDateString(), selectedCreatedDateRange: this.createdDateRangeStart.toLocaleDateString() + "  -  " + this.createdDateRangeEnd.toLocaleDateString() });
    }

    onSelectClass = (options, isMannual = false) => {
        let values = options.map(option => option?.value)

        this.setState({ selectedClass: values }, () => {
        })
    }


    getStudentEngagementActivityReport() {

        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            dateRangeStart: this.createdDateRangeStart,
            dateRangeEnd: this.createdDateRangeEnd,
            subjectId: this.state.selectedSubject
        }

        if (this.state.selectedClass.length === 0 || !this.state.selectedCreatedDateRange ||
            !this.state.selectedBoard || !this.state.selectedSubject) {
            this.setState({ isCreate: true })
            return
        }

        this.setState({ isLoading: true })

        SchoolApi.getStudentEngagementReport(payload).then(res => {
            // console.log(res)
            this.setState({ isLoading: false })

            this.downloadStudentEngagementReport(res.pdfLink)

        }).catch(err => {
            console.log(err)
            this.setState({ isLoading: false })
            alert("Error while generating the report. Please try again later.")
        })

    }

    downloadStudentEngagementReport(pdfLink) {
        if (!pdfLink) {
            alert("Report generated, but download link was not found.")
            return
        }

        if (window.electron?.ipcRenderer) {
            window.electron.ipcRenderer.send('download-pdf', {
                payload: {
                    fileURL: pdfLink
                }
            })
            return
        }
        // this.alert("Report generated successfully.")
        const link = document.createElement("a");
        link.href = pdfLink;
        link.target = "_blank";
        link.download = "student_engagement_report.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    clearFilter() {
        this.setState({
            selectedBoard: '',
            selectedClass: [],
            selectedCreatedDateRange: '',
            selectedSubject: '',
            isCreate: false, reloadDropdown : true, reloadSubjectDropdown : true
        }, () => {
            this.setState({reloadDropdown : false, reloadSubjectDropdown : false})
            this.getClasses()
        })
    }


    render() {
        return (
            <div className="student-engagement-report">
                {this.state.isLoading && <Loading />}
                <div>
                    <div className="title">Student Engagement Report</div>
                </div>

                <div className="row student-leaderboard-class-filter mr-4">
                    {
                        this.state.boardsDropdownItems.length > 1 ?
                            <div className="col-lg-2 col-md-6 col-sm-12 pt-4">
                                <div className="filter-input-label">
                                    Board<span className='text-danger'>*</span>
                                </div>
                                <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                    <Dropdown
                                        placeholder='Select a board'
                                        options={this.state.boardsDropdownItems}
                                        onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                        text={"title"}
                                        value={this.state.selectedBoard}
                                    />
                                </div>
                                {this.state.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                            </div>
                            : ""
                    }
                    <div className="col-lg-2 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Subject<span className='text-danger'>*</span>
                        </div>
                        <div className={this.props.isCreate && !this.state.selectedSubject ? 'error-border' : ''}>
                            {
                                !this.state.reloadSubjectDropdown ?
                                <Dropdown
                                placeholder='Select a subject'
                                options={this.state.subjectsDropdownItems}
                                onSelect={(option) => this.onSelectDropDown(option, "selectedSubject")}
                                text={"title"}
                                value={this.state.selectedSubject}
                            />
                            :
                            ''
                            }
                            
                        </div>
                        {this.state.isCreate && !this.state.selectedSubject ? <div className='error-text text-danger'>Please Select a subject</div> : ''}
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Class<span className='text-danger'>*</span>
                        </div>
                        <div className={this.props.isCreate && !this.state.selectedClass ? 'error-border' : ''}>
                            {
                                !this.state.reloadDropdown ?
                                    <DropdownV4
                                        key="section-multi"
                                        placeholder='Select a Class'
                                        options={this.state.classDropdownItems}
                                        onSelect={(option) => this.onSelectClass(option, true)}
                                        text={"title"}
                                        multiSelect={true}
                                        value={this.state.selectedClass}
                                    >
                                    </DropdownV4>
                                    : ""
                            }
                        </div>
                        {this.state.isCreate && !this.state.selectedClass.length ? <div className='error-text text-danger'>Please Select a Class</div> : ''}
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Date<span className='text-danger'>*</span>
                        </div>
                        <div>
                            <DateRangePicker onHide={this.handleCreatedDateEvent} onCancel={() => { }}
                                autoApply
                                maxDate={new Date().toLocaleDateString()}
                                initialSettings={{ singleDatePicker: false, startDate: this.createdDatesRangeStart, endDate: this.createdDateRangeEnd, autoUpdateInput: false }}
                                locale={{
                                    'format': 'DD/MM/YYYY'
                                }}
                            // maxDate={new Date().toLocaleDateString()}
                            ><input className="cw-input" style={{ border: '1px solid #4BC3C6', backgroundColor: '#F3FFFF', height: '2.3rem' }} placeholder="Select date" value={this.state.selectedCreatedDateRange}></input>
                            </DateRangePicker>
                        </div>
                        {this.state.isCreate && !this.state.selectedCreatedDateRange ? <div className='error-text text-danger'>Please Select a Date</div> : ''}
                    </div>
                    <div className="row col-lg-3 col-md-6 col-sm-12 pt-4 ml-2">
                        <div className="filter-button  d-inline-block">
                            <button className={`cw-button`} onClick={() => this.getStudentEngagementActivityReport()}>{"GO"}</button>
                        </div>
                        <div className="filter-button ml-3 d-inline-block">
                            <button className={`cw-button clear-btn`} onClick={() => this.clearFilter()}>{"CLEAR"}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StudentEngagementReport;
